module.exports = __webpack_public_path__ + "img/img_default_thum_2.bdae7587.svg";